import { previewTypes } from '../constants/preview-types';

const getTrailerTypeString = videoItem => {
  if (!videoItem) {
    return 'none';
  }

  let { trailerType } = videoItem;
  trailerType = trailerType || previewTypes.FIRST_20_SEC;

  switch (trailerType) {
    case previewTypes.FIRST_20_SEC:
      return 'preview';
    case previewTypes.TRAILER:
      return 'trailer';
    case previewTypes.NONE:
    default:
      return 'none';
  }
};

export default getTrailerTypeString;



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/bi-selectors/get-trailer-type-string.js